import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    videoModal: {
        maxWidth: '100%',
        maxHeight: '100%',
        width: '300px',
        height: '200px',
        [theme.breakpoints.up('md')]: {
            width: '400px',
            height: '300px',
        },
    }
}))

const SynthesiaVideoModal = (props) => {
    const { modalIsOpen } = props
    const classes = useStyles()
    const theme = useTheme()
    return (
        <React.Fragment>
            <Dialog
                id="greeting-card-image-modal"
                maxWidth={'lg'}
                open={modalIsOpen}
                onClose={props.closeModal}
                aria-labelledby="Greeting Card"
            >
                <DialogTitle id="max-width-dialog-title">
                    <IconButton
                        data-testid="close-button"
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={props.closeModal}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        style={{
                            padding: '1rem',
                        }}
                    >
                        <Grid item xs={12}>
                            <div className={classes.videoModal}>
                                <div style={{
                                    position: 'relative',
                                    overflow: 'hidden',
                                    paddingTop: '56.25%',
                                }}>
                                    <iframe
                                        src="https://share.synthesia.io/embeds/videos/9b2acca1-af4a-4a6d-a7ff-fdcb9b4ab2c4"
                                        loading="{'lazy'}"
                                        title="{'Synthesia video player - BIN'}"
                                        allow="{'encrypted-media; fullscreen;'}"
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            top: 0,
                                            left: 0,
                                            border: 0,
                                            padding: 0,
                                            margin: 0,
                                            overflow: 'hidden'
                                        }}
                                    ></iframe>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default SynthesiaVideoModal
